import { apiFetch } from "./client";

export interface AuthMethods {
  github: boolean;
  google: boolean;
}

/**
 * Which sign-in providers this deployment is actually configured for.
 * The login page offered "Continue with Google" unconditionally, which sent
 * visitors to a Google error page when no client ID was configured.
 */
export async function getAuthMethods(): Promise<AuthMethods> {
  return apiFetch<AuthMethods>({ path: "/auth/methods" });
}
